import { Badge, BadgeProps } from '@chakra-ui/core'
import React from 'react'

export const ConsoleBadge = React.forwardRef<HTMLSpanElement, BadgeProps>(({ children, ...props }, ref) => {
  return (
    <Badge
      fontSize="11px"
      ref={ref}
      rounded="full"
      border="0.5px solid"
      px={2}
      textAlign="center"
      w="fit-content"
      {...props}
    >
      {children}
    </Badge>
  )
})
